// import React, { useState, useRef } from 'react';
// import {
//     Box, Typography, TextField, Button, Paper, Stack, styled
// } from '@mui/material';
// import { GoogleMap, useJsApiLoader, Marker, Autocomplete } from '@react-google-maps/api';
// import SearchBar from './FormsSearchBar';
// import FormsBottomNavbar from './FormsBottomNavbar';
// import { useNavigate } from 'react-router-dom';

// const GOOGLE_MAPS_API_KEY = 'AIzaSyAZAU88Lr8CEkiFP_vXpkbnu1-g-PRigXU'; // Replace with your actual API key

// const containerStyle = {
//     width: '100%',
//     height: '300px',
// };

// const centerDefault = {
//     lat: 18.387449,
//     lng: 78.803236,
// };

// // ✅ Styled buttons
// const RedButton = styled(Button)({
//     backgroundColor: 'red',
//     color: 'white',
//     '&:hover': { backgroundColor: '#cc0000' },
// });
// const GreenButton = styled(Button)({
//     backgroundColor: 'green',
//     color: 'white',
//     '&:hover': { backgroundColor: '#008000' },
// });
// const PostYourBestDeal = () => {
//      const { isLoaded } = useJsApiLoader({
//                 id: 'google-map-script',
//                 googleMapsApiKey: GOOGLE_MAPS_API_KEY,
//                 libraries: ['places'],
//             });
//     const [location, setLocation] = useState(centerDefault);
//     const [address, setAddress] = useState('');
//     const autocompleteRef = useRef(null);
//     const navigate = useNavigate();

//     // ✅ Handle selection from Google Places dropdown
//     const onPlaceChanged = () => {
//         if (autocompleteRef.current) {
//         const place = autocompleteRef.current.getPlace();
//         if (place && place.geometry) {
//             const newLoc = {
//                 lat: place.geometry.location.lat(),
//                 lng: place.geometry.location.lng(),
//             };
//             setLocation(newLoc);
//             setAddress(place.formatted_address);
//         }
//     }
//     };

//     // ✅ Handle manual address entry
//     const geocodeAddress = async () => {
//         if (window.google && window.google.maps) {
//         const geocoder = new window.google.maps.Geocoder();
//         geocoder.geocode({ address }, (results, status) => {
//             if (status == 'OK' && results[0]) {
//                 const location = results[0].geometry.location;
//                 setLocation({
//                     lat: location.lat(),
//                     lng: location.lng(),
//                 });
//                 setAddress(results[0].formatted_address);
//             } else {
//                 alert('Address could not be located. Please check input.');
//             }
//         });
//     }
//     };

//     // ✅ Optional callback handlers for SearchBar
//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     const handleSearchClick = () => {
//         console.log('Search icon clicked');
//     };

//     const handleFilterClick = () => {
//         console.log('Filter icon clicked');
//     };
//      if (!isLoaded) {
//                 return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//                     <Typography>Loading Google Maps...</Typography>
//                 </Box>;
//             }

//     return (
//         <>
//             {/* ✅ Add SearchBar at the top */}
//             <SearchBar
//                 onBackClick={handleBackClick}
//                 onSearchClick={handleSearchClick}
//                 onFilterClick={handleFilterClick}
//             />
//             <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', pt:'10px', backgroundColor: 'rgb(239, 231, 221)' }}>
//             <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 'md', mx: 'auto' }}>
//                 <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
//                     Post Your Best Deal
//                 </Typography>

//                 <Paper elevation={2} sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
//                     {/* ✅ Basic Input Fields */}
//                     <TextField fullWidth label="Property Type" variant="outlined" sx={{ mb: 2 }} />
//                     <TextField fullWidth label="Budget" variant="outlined" sx={{ mb: 2 }} />

//                     {/* ✅ Location Search using Google Autocomplete */}
//                     <Autocomplete
//                         onLoad={ref => (autocompleteRef.current = ref)}
//                         onPlaceChanged={onPlaceChanged}
//                     >
//                         <TextField
//                             fullWidth
//                             label="Location"
//                             variant="outlined"
//                             value={address}
//                             onChange={e => setAddress(e.target.value)}
//                             onBlur={geocodeAddress}
//                             sx={{ mb: 2 }}
//                         />
//                     </Autocomplete>

//                     {/* ✅ Google Map and Marker */}
//                     <GoogleMap
//                         mapContainerStyle={containerStyle}
//                         center={location}
//                         zoom={15}
//                     >
//                         <Marker position={location} />
//                     </GoogleMap>

//                     <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         Description
//                     </Typography>
//                     <TextField fullWidth variant="outlined" multiline rows={4} />
//                     <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
//                         <RedButton variant="contained" size="large" sx={{ px: 4, fontWeight: 'bold' }}  
//                         onClick={() => navigate(-1)}>
//                             Cancel
//                         </RedButton>
//                         <GreenButton variant="contained" size="large" sx={{ px: 4, fontWeight: 'bold' }}>
//                             Submit
//                         </GreenButton>
//                     </Stack>
//                 </Paper>
//                 <Box sx={{ height: '70px' }} />

//             </Box>
//             </Box>
//             <FormsBottomNavbar />
//         </>
//     );
// };

// export default PostYourBestDeal;






import React, { useState, useRef, useContext, useEffect } from 'react';
import {
    Box, Typography, TextField, Button, Select, MenuItem,
    InputLabel, FormControl, Paper, Stack, styled
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useJsApiLoader, GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import SearchBar from './FormsSearchBar'; 
import FormsBottomNavbar from './FormsBottomNavbar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IconButton, InputAdornment } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { AuthContext  } from './../../AuthContext/AuthContext';
import {BASE_URL} from './../../Api/ApiUrls';
import SubscriptionGuard from './SubscriptionGuard';
import { checkPropertyUploadLimit } from './SubscriptionUtils';
import UploadStatusModal from './UploadStatusModal';
import {GOOGLEMAPS_API_KEY} from './../../Api/ApiUrls';

const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY; // Replace with your actual API key

const containerStyle = {
    width: '100%',
    height: '300px',
};

const centerDefault = {
    lat: 18.387449,
    lng: 78.803236,
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const RedButton = styled(Button)({
    backgroundColor: 'red',
    color: 'white',
    '&:hover': { backgroundColor: '#cc0000' },
});

const GreenButton = styled(Button)({
    backgroundColor: 'green',
    color: 'white',
    '&:hover': { backgroundColor: '#008000' },
});

// const fieldMap = {
//     'Commercial land/plot': ['Site Area', 'Facing', 'List', 'Price', 'Roadwidth'],
//     'plot/land': ['Site Area', 'Facing', 'List', 'Price', 'Roadwidth'],
//     'rent with duplex building': ['Site Area', 'Facing', 'List', 'Price', 'No of floors', 'Buildup area', 'Borewell', 'Parking', '1bhk-count', '2bhk-count', 'Duplex bedrooms', 'Roadwidth'],
//     'duplex house': ['Site Area', 'Facing', 'List', 'Price', 'No of floors', 'Buildup area', 'Borewell', 'Parking', 'Duplex bedrooms', 'Roadwidth'],
//     'rental building': ['Site Area', 'Facing', 'List', 'Price', 'No of floors', 'Buildup area', 'Borewell', 'Parking', '1bhk-count', '2bhk-count', '3bhk-count', 'Roadwidth'],
//     'pg-offices': ['Site Area', 'Facing', 'List', 'Price', 'Rooms-count', 'Floors', 'Borewell', 'Parking', 'Roadwidth'],
//     'flat': ['Site Area', 'Facing', 'List', 'Price', 'Bedrooms-count', 'Parking', 'Borewell', 'Roadwidth'],
//     'villa': ['Site Area', 'Facing', 'List', 'Price', 'Bedrooms-count', 'Parking', 'Borewell', 'Floors', 'Roadwidth'],
//     'commercial building': ['Site Area', 'Facing', 'List', 'Price', 'Shop-count', 'Parking', 'Borewell', 'Floors', 'Roadwidth'],
//     'Apartment': ['Site Area', 'Facing', 'List', 'Price', 'Parking', 'Borewell', 'House-count', '1bhk', '2bhk', '3bhk', '4bhk', 'Roadwidth'],
//     'others': ['Price', 'Roadwidth'],
// };

const fieldMap = { 
    // 'Commercial land/plot': ['Site Area', 'Facing',  'Price', 'Road Width'],
    'Plot/land': ['Site Area', 'Facing',  'Price', 'Road Width'],
    // 'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms','Lift', 'Road Width'],
    // 'Duplex house': ['Property Name', 'Site Area', 'Facing',  'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms','Lift', 'Road Width'],
    // 'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count','Lift', 'Road Width'],
    // 'Pg-offices': ['Property Name', 'Site Area', 'Facing',  'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
    // 'Flat': ['Property Name', 'Site Area', 'Facing',  'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
    'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    // 'Commercial building': ['Property Name', 'Site Area', 'Facing',  'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Apartment': ['Property Name', 'Site Area', 'Facing',  'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
    // 'JV/JD': ['Site Area', 'Facing',  'Price', 'Road Width'],
};

const facingOptions = ['East', 'West', 'North', 'South', 'North-East', 'North-West', 'South-East', 'South-West'];

 const yesNoOptions = ['Yes', 'No'];

const PostYourBestDeal = () => { 
    const [workPhotos, setWorkPhotos] = useState([]);
    const { userId, logout } = useContext(AuthContext);
    const [apiHitCount, setApiHitCount] = useState(0);
    const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
    const [postedBy, setPostedBy] = useState('');

         const [uploadStatus, setUploadStatus] = useState(null);
      const [showStatusModal, setShowStatusModal] = useState(false);
    
     useEffect(() => {
        const checkStatus = async () => {
          const status = await checkPropertyUploadLimit(userId, 'Individual Owner/Builder', 'best-deal'); 
          setUploadStatus(status);
          
          // Show modal only when first loading the page
          setShowStatusModal(true);
        };
    
        checkStatus();
      }, [userId]);

       const generateNumberOptions = (max = 50) => {
    const options = [];
    for (let i = 0; i <= max; i++) {
        options.push(i);
    }
    return options;
};

    // const handleChange = (event) => {
    //     const value = event.target.value;
    //     setPostedBy(value);
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       posted_by: value
    //     }));
    //   };
      
const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "posted_by") {
        setPostedBy(value);  // For posted_by field
        setFormData((prevData) => ({
            ...prevData,
            posted_by: value,  // Update formData for posted_by
        }));
    } else if (name === "description") {
        // Handle description field
        setFormData((prevData) => ({
            ...prevData,
            description: value,  // Update formData for description
        }));
        setFormValues((prev) => ({
            ...prev,
            description: value,  // Update formValues for real-time change
        }));
    } else {
        // Generic handling for other fields
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
};


    const handleWorkPhotosChange = (e) => {
        if (e.target.files) {
            setWorkPhotos(Array.from(e.target.files));
        }
    };
    
    const [formData, setFormData] = useState({
        user_id: userId, 
        category_id: '', 
        // type: 'sell',
        mobile_no: '',
        facing: '',
        roadwidth: '',
        site_area: '',
        buildup_area: '',
        posted_by: '',
        price: '',
        borewell: '',
        location: '',
        lat: '',
        long: '',
        units: 'ft', // Add this line
        nearby: 'Gandi Hospital',
        length: '',
        width: '',
        no_of_flores: '',
        _1bhk_count: '',
        _2bhk_count: '',
        _3bhk_count: '',
        _4bhk_count: '',
        bedrooms_count: '',
        bathrooms_count: '4',
        balcony: '',
        gated_security: 'yes',
        parking: '',
        advance_payment: '',
        duplex_bedrooms: '',
        power_backup: 'yes',
        rooms_count: '',
        shop_count: '',
        house_count: '',
         property_name: '',
        lift: '',
         description: '',
    });

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    });
    const [markerIcon, setMarkerIcon] = useState(null);

useEffect(() => {
  if (isLoaded && window.google) {
    setMarkerIcon({
      url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23ff0000%22%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
      scaledSize: new window.google.maps.Size(40, 40),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(20, 40)
    });
  }
}, [isLoaded]);

    const [location, setLocation] = useState(centerDefault);
    const [address, setAddress] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [formValues, setFormValues] = useState({});
    const autocompleteRef = useRef(null);
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchMobileNo = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/users/`);
                const users = response.data;
                
                console.log('All users from API:', users);
                console.log('Current userId:', userId);
    
                const matchedUser = users.find(user => user.user_id == userId);
                
                if (matchedUser) {
                    setFormData((prevData) => ({
                        ...prevData,
                        mobile_no: matchedUser.mobile_no,
                    }));
                    console.log('Fetched and set mobile_no:', matchedUser.mobile_no);
                } else {
                    console.warn(`User with ID ${userId} not found`);
                }
            } catch (error) {
                console.error('Error fetching mobile_no:', error);
            }
        };
    
        if (userId) {
            fetchMobileNo();
        }
    }, [userId]);
    
    
    // Track API hits
    const incrementApiHit = () => {
        setApiHitCount(prev => prev + 1);
        console.log(`Google Maps API hits: ${apiHitCount + 1}`);
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
          setUsingCurrentLocation(true);
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              setLocation(pos);
      
              try {
                const response = await fetch(
                  `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
                );
                const data = await response.json();
      
                if (data.status == 'OK' && data.results.length > 0) {
                  const address = data.results[0].formatted_address;
                  setAddress(address);
                } else {
                  console.warn('No address found, fallback to coordinates.');
                  setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
                }
              } catch (error) {
                console.error('Google Maps API error:', error);
                setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
              }
            },
            (error) => {
              console.error("Error getting current location:", error);
              alert("Error getting current location. Please enable location services.");
            }
          );
        } else {
          alert("Geolocation is not supported by this browser.");
        }
      };
      const onPlaceChanged = () => {
        if (autocompleteRef.current) {
          const place = autocompleteRef.current.getPlace();
          if (place && place.geometry) {
            incrementApiHit();
            setUsingCurrentLocation(false);
            const newLoc = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            setLocation(newLoc);
            setAddress(place.formatted_address);
          }
        }
      };

    const geocodeAddress = async () => {
        if (!address) return;
        
        if (usingCurrentLocation) {
            // Don't use API if we're using current location
            return;
        }

        if (window.google && window.google.maps) {
            incrementApiHit(); // This uses Google Maps API
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status == 'OK' && results[0]) {
                    const location = results[0].geometry.location;
                    setLocation({
                        lat: location.lat(),
                        lng: location.lng(),
                    });
                    setAddress(results[0].formatted_address);
                } else {
                    alert('Address could not be located. Please check input.');
                }
            });
        }
    };

    const labelKeyMap = {
        'Site Area': 'site_area',
        'Facing': 'facing',
        'Price': 'price',
        'No.of Floors': 'no_of_flores',
        'Buildup Area': 'buildup_area',
        'Borewell': 'borewell',
        'Lift': 'lift',
        'No.of Cars Parking': 'parking',
        '1bhk Count': '_1bhk_count',
        '2bhk Count': '_2bhk_count',
        '3bhk Count': '_3bhk_count',
        '4bhk Count': '_4bhk_count',
        'Duplex Bedrooms': 'duplex_bedrooms',
        'Floors': 'no_of_flores',
        'Rooms Count': 'rooms_count',
        // 'Bedrooms-count': 'bedrooms_count',
        'No.of Bedrooms': 'bedrooms_count',
        'Shop Count': 'shop_count',
        'House Count': 'house_count',
        '1bhk': '_1bhk_count',
        '2bhk': '_2bhk_count',
        '3bhk': '_3bhk_count',
        
        'Road Width': 'roadwidth',
        'Length': 'length',
        'Width': 'width',
        'Property Name': 'property_name'
    };

    const handleBackClick = () => navigate(-1);

//    const handleFieldChange = (label, value) => {
//   const key = labelKeyMap[label] || label;
  
//   // List of fields that should only accept numeric values
//   const numericFields = [
//     'Price',
//     // 'Road Width',
//     // 'Buildup Area',
//     // 'Site Area',
//     // 'Length',
//     // 'Width',
//     // Add any other numeric fields here
//   ];

//   if (numericFields.includes(label)) {
//     // Allow only numbers, single decimal point, and empty string
//     const numericRegex = /^[0-9]*\.?[0-9]*$/;
    
//     if (value === '' || numericRegex.test(value)) {
//       setFormValues(prev => ({ ...prev, [label]: value }));
//       setFormData(prev => ({ ...prev, [key]: value }));
//     }
//   } else {
//     // For non-numeric fields, update normally
//     setFormValues(prev => ({ ...prev, [label]: value }));
//     setFormData(prev => ({ ...prev, [key]: value }));
//   }
// };

  const getBuildupAreaLabel = () => { 
  const unit = formData.units || 'ft';
  const unitMap = {
    ft: 'Buildup Area (sqft)',
    m: 'Buildup Area (sqm)',
    cm: 'Buildup Area (sqcm)',
    in: 'Buildup Area (sqin)'
  };
  return unitMap[unit] || 'Buildup Area';
};

const isNumericField = (label) => {
  const numericFields = [
    'Price',
    'Road Width',
    'Buildup Area',
    'Site Area',
    'Length',
    'Width',
    // Add other numeric fields
  ];
  return numericFields.includes(label);
};

const isValidNumber = (value) => {
  return value === '' || /^[0-9]*\.?[0-9]*$/.test(value);
};

const handleFieldChange = (label, value) => {
  const key = labelKeyMap[label] || label;
  
  if (isNumericField(label) && !isValidNumber(value)) {
    return; // Block invalid input
  }

  // Update both formValues and formData
  setFormValues(prev => ({ ...prev, [label]: value }));
  
  // Special case: Length/Width are in formData
  if (label === 'Length' || label === 'Width') {
    setFormData(prev => ({ ...prev, [label.toLowerCase()]: value }));
  } else {
    setFormData(prev => ({ ...prev, [key]: value }));
  }
};

    const handleMapClick = async (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setLocation({ lat, lng });
        setUsingCurrentLocation(false);
        incrementApiHit();
      
        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status == 'OK' && results[0]) {
              setAddress(results[0].formatted_address);
            } else { 
              setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
            }
          });
        }
      };

   useEffect(() => {
    axios.get(`${BASE_URL}/property-category/`)
        .then(response => {
            const filteredCategories = response.data.filter(
                cat => cat.category_type.toLowerCase() === 'sell' &&
                    ["Plot/land", "Villa", "Apartment"].includes(cat.category)
            );
            setCategories(filteredCategories);
        })
        .catch(error => {
            console.error("Error fetching categories:", error);
        });
}, []);


    const groupedCategories = categories.reduce((acc, curr) => {
        const type = curr.category_type;
        if (!acc[type]) acc[type] = [];
        acc[type].push(curr);
        return acc;
    }, {});

    const handleSubmit = async (e) => {
        e.preventDefault();
      const uploadCheck = await checkPropertyUploadLimit(userId, 'Individual Owner/Builder', 'best-deal');
          
          if (!uploadCheck.canUpload) {
            alert(uploadCheck.message);
            return;
          }
        
        console.log('Form submission initiated');
        console.log('Current formData:', formData);
        console.log('Location:', location);
        console.log('Address:', address);
        console.log('Work photos count:', workPhotos.length);
    
        // Calculate site area in original units
        const length = parseFloat(formData.length) || 0;
        const width = parseFloat(formData.width) || 0;
        const site_area = length * width;
    
        console.log('Length:', length, formData.units);
        console.log('Width:', width, formData.units);
        console.log('Calculated Site Area:', site_area, `${formData.units}²`);
    
        const updatedFormData = {
            ...formData,
            lat: location.lat.toString(),
            long: location.lng.toString(),
            location: address,
            site_area: site_area.toString(),
            type: 'best-deal',
            Admin_status: 'Pending',
            // mobile_no: formData.mobile_no,
             description: formData.description,
        };
    
        console.log('Data being prepared for submission:', updatedFormData);
    
        const formDataToSend = new FormData();
    
        // Log each form data entry
        Object.entries(updatedFormData).forEach(([key, value]) => {
            formDataToSend.append(key, value);
            console.log(`Appended to formData: ${key} =`, value);
        });
    
        // Log each file being uploaded
        workPhotos.forEach((file, index) => {
            formDataToSend.append('new_property_images', file);
            console.log(`Appended file ${index + 1}:`, file.name, file.type, `${(file.size / 1024).toFixed(2)}KB`);
        });
    
        console.log('FormData prepared, sending to server...');
    
        try {
            console.log('Making POST request to:', `${BASE_URL}/property/`);
            
            const response = await axios.post(`${BASE_URL}/property/`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            console.log('Server response:', response);
            
            if (response.status == 201 || response.status == 200) {
                console.log('Success! Response data:', response.data);
                alert('Property submitted successfully!');
                 if (uploadCheck.remaining !== undefined) {
        alert(`Remaining uploads: ${uploadCheck.remaining - 1}`);
      }
                navigate('/dashboard');
            } else {
                console.warn('Unexpected status code:', response.status);
                alert('Something went wrong. Try again.');
            }
        } catch (error) {
            console.error('Submission Error:', error);
            
            if (error.response) {
                console.error('Error response data:', error.response.data);
                console.error('Error status:', error.response.status);
                console.error('Error headers:', error.response.headers);
                
                alert(`Error: ${error.response.data.message || 'Something went wrong'}`);
            } else if (error.request) {
                console.error('No response received:', error.request);
                alert('No response from server. Please check your connection.');
            } else {
                console.error('Request setup error:', error.message);
                alert('An error occurred while submitting. Please try again.');
            }
        } finally {
            console.log('Submission process completed');
        }
    };

    if (!isLoaded) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography>Loading Google Maps...</Typography>
            </Box>
        );
    }

    const fields = selectedCategory && fieldMap[selectedCategory] ? fieldMap[selectedCategory] : [];

    return (
        <>
            <SearchBar onBackClick={handleBackClick} /> 
              <SubscriptionGuard
                          user_types={['Individual Owner/Builder', 'Agent']}>
                      <Box
             sx={{
               display: 'flex',
               flexDirection: 'column',
               minHeight: '100vh',
               pt: '10px',
               backgroundColor: 'rgb(239, 231, 221)',
             }}
           >
             <Box
               sx={{
                 flexGrow: 1,
                 p: { xs: 2, sm: 3 },
                 pb: 10,
                 display: 'flex',
                 justifyContent: 'center', // center horizontally
               }}
             >
              
               <Paper
                 elevation={2}
                 sx={{
                   p: { xs: 2, sm: 3 },
                   mb: 3,
                   width: '100%',
                   boxSizing: 'border-box',
                 }}
                 component="form"
                 onSubmit={handleSubmit}
               >
                    <Typography
                   variant="h5"
                   gutterBottom
                   sx={{ fontWeight: 'bold',mb: 3, textAlign: 'center' }}
                 >
                   Post Your Best Deal
                 </Typography>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                            <InputLabel id="category-label">Select Property Type</InputLabel>
                            <Select
                                labelId="category-label"
                                value={selectedCategory}
                                onChange={(e) => {
                                    const selected = categories.find(cat => cat.category == e.target.value);
                                    setSelectedCategory(selected.category);
                                    setFormData(prev => ({
                                        ...prev,
                                        category_id: selected.category_id,
                                        type: selected.category_type,
                                    }));
                                }}
                                label="Select Category"
                            >
                                {Object.entries(groupedCategories).map(([type, items]) => [
                                    ...items.map(cat => (
                                        <MenuItem key={cat.category_id} value={cat.category}>
                                            {cat.category}
                                        </MenuItem>
                                    ))
                                ])}
                            </Select>
                        </FormControl>

{fields.includes('Site Area') && (
  <Box key="Site Area" sx={{ mb: 2 }}>
    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
      Site Dimensions
    </Typography>
    <Stack direction="row" spacing={2}>
      <TextField 
        fullWidth 
        label="Length" 
        variant="outlined"
        value={formData.length || ''}
        onChange={(e) => handleFieldChange('Length', e.target.value)}
      />
      <TextField 
        fullWidth 
        label="Width" 
        variant="outlined"
        value={formData.width || ''}
        onChange={(e) => handleFieldChange('Width', e.target.value)}
      />
      <TextField 
        select 
        label="Units" 
        defaultValue="ft" 
        sx={{ minWidth: 100 }}
        value={formData.units || 'ft'}
        onChange={(e) => setFormData(prev => ({ ...prev, units: e.target.value }))}
      >
        {['ft', 'm', 'cm', 'in'].map((unit) => (
          <MenuItem key={unit} value={unit}>{unit}</MenuItem>
        ))}
      </TextField>
    </Stack>
  </Box>
)}
                                             {fields.map((label) => {
                          if (label == 'Site Area') return null;

                           if (label === 'Buildup Area') {
                              return (
                                <TextField
                                  key={label}
                                  fullWidth
                                  label={getBuildupAreaLabel()}
                                  variant="outlined"
                                  sx={{ mb: 2 }}
                                  value={formValues[label] || ''}
                                  onChange={(e) => handleFieldChange(label, e.target.value)}
                                  type="number"
                                  inputProps={{ 
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    min: 0 
                                  }}
                                />
                              );
                            }
                      
                          if (label == 'Facing') {
                              return (
                                  <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                                      <InputLabel id={`${label}-label`}>{label}</InputLabel>
                                      <Select
                                          labelId={`${label}-label`}
                                          value={formValues[label] || ''}
                                          label={label}
                                          onChange={(e) => handleFieldChange(label, e.target.value)}
                                      >
                                          {facingOptions.map(option => (
                                              <MenuItem key={option} value={option}>{option}</MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              );
                          }
                      
                          if (label == 'Borewell' || label == 'Lift') {
                              return (
                                  <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                                      <InputLabel id={`${label}-label`}>{label}</InputLabel>
                                      <Select
                                          labelId={`${label}-label`}
                                          value={formValues[label] || ''}
                                          label={label}
                                          onChange={(e) => handleFieldChange(label, e.target.value)}
                                      >
                                          {yesNoOptions.map(option => (
                                              <MenuItem key={option} value={option}>{option}</MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              );
                          }
                      
                          if (label == 'No.of Cars Parking' || label == 'No.of Floors' || label == 'Floors' || label == 'No.of Bedrooms' || label == 'Rooms Count' || label == 'Shop Count' || label == 'House Count' || label == 'Duplex Bedrooms' || label == '1bhk Count' || label == '2bhk Count' || label == '3bhk Count' || label == '1bhk' || label == '2bhk' || label == '3bhk' || label == '4bhk Count') {
                              return (
                                  <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                                      <InputLabel id={`${label}-label`}>{label}</InputLabel>  
                                      <Select
                                          labelId={`${label}-label`}
                                          value={formValues[label] || ''}
                                          label={label}
                                          onChange={(e) => handleFieldChange(label, e.target.value)}
                                          MenuProps={{
                                              PaperProps: {
                                                  style: {
                                                      maxHeight: 200, // Limits dropdown height and adds scroll
                                                  },
                                              },
                                          }}
                                      >
                                          {generateNumberOptions().map(number => (
                                              <MenuItem key={number} value={number}>{number}</MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              );
                          }
                      
                          return (
                              <TextField
  key={label}
  fullWidth
  label={label}
  variant="outlined"
  sx={{ mb: 2 }}
  value={formValues[label] || ''}
  onChange={(e) => handleFieldChange(label, e.target.value)}
  type={isNumericField(label) ? 'number' : 'text'}
  inputProps={isNumericField(label) ? { 
    inputMode: 'numeric',
    pattern: '[0-9]*',
    min: 0 
  } : {}}
/>
                          );
                      })}
                      

                        {/* Location Section */}
                    {/* Location Section */}
<Box sx={{ mb: 2 }}>
  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
    Location
  </Typography>

  {isLoaded && (
    <Autocomplete
      onLoad={(autocomplete) => {
        autocompleteRef.current = autocomplete;
      }}
      onPlaceChanged={onPlaceChanged}
    >
      <TextField
        fullWidth
        label="Search Location"
        variant="outlined"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        onBlur={geocodeAddress}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={getCurrentLocation} edge="end">
                <MyLocationIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Autocomplete>
  )}

  {/* Map with marker */}
  <div style={containerStyle}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    onClick={handleMapClick}
  >
    {markerIcon && (
      <Marker 
        position={location} 
        icon={markerIcon}
      />
    )}
  </GoogleMap>
</div>
</Box>

                        {/* API Hit Counter (for debugging) */}
                        {/* <Typography variant="caption" sx={{ display: 'block', textAlign: 'right', mt: 1 }}>
                            Google Maps API hits: {apiHitCount}
                        </Typography> */}

                        {/* Image Upload */}
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>Uploaded Images</Typography>
                        <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ mb: 3 }}>
                            Upload Images
                            <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleWorkPhotosChange}
                            />
                        </Button>
                        {workPhotos.length > 0 && (
                            <Typography variant="caption" display="block" gutterBottom>
                                Selected: {workPhotos.length} file(s)
                            </Typography>
                        )}

<FormControl fullWidth margin="normal">
        <InputLabel id="posted-by-label">Posted By</InputLabel>
        <Select
          labelId="posted-by-label"
                                    value={postedBy}  // Set value to postedBy state
                                    label="Posted by"
                                    name="posted_by"  // The name attribute to match handleChange
                                    onChange={handleChange}
          required
        >
          <MenuItem value="Owner">Owner</MenuItem>
          <MenuItem value="Agent">Agent</MenuItem>
          <MenuItem value="Builder">Builder</MenuItem>
        </Select>
      </FormControl>

                        {/* Description */}
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>Description</Typography>
                         <TextField
                            fullWidth
                           
                            variant="outlined"
                            multiline
                            rows={4}
                            name="description"  // Make sure name matches the key in the state
                            value={formValues.description || ''}  // Bind to formValues for real-time input update
                            onChange={handleChange}  // Handle changes with handleChange
                            sx={{ mb: 2 }}  // Optional styling for spacing
                        />

                        {/* Buttons */}
                        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2,mb: 2 }}>
                            <RedButton variant="contained" size="large" sx={{ px: 4, fontWeight: 'bold' }}
                            onClick={() => navigate(-1)}>
                                Cancel
                            </RedButton>
                           <UploadStatusModal
        open={showStatusModal}
        onClose={() => setShowStatusModal(false)}
        uploadStatus={uploadStatus}
        onUpgrade={() => {
          setShowStatusModal(false);
          navigate('/user-subscription');
        }}
      />

      {/* Your existing form JSX */}
      <GreenButton
        variant="contained"
        size="large"
        sx={{ px: 4, fontWeight: 'bold' }}
        type="submit"
        disabled={uploadStatus && !uploadStatus.canUpload}
      >
        {uploadStatus && !uploadStatus.canUpload ? 'Upload Limit Reached' : 'Submit'}
      </GreenButton>
                        </Stack>
                    </Paper>
                    <Box sx={{ height: '70px' }} />
                </Box>
            </Box>
            </SubscriptionGuard>
            <FormsBottomNavbar />
        </>
    );
};

export default PostYourBestDeal;
